export enum AttendanceSheetNotificationEnum {
  FOLHA_CRIADA = 1,
  FOLHA_ASSINADA = 2,
  FOLHA_REJEITADA = 3,
  FOLHA_CONCLUIDA = 4,
}

export function attendanceSheetNotificationInFull(status: AttendanceSheetNotificationEnum): string {
  switch (status) {
    case AttendanceSheetNotificationEnum.FOLHA_CRIADA:
      return 'Folha Criada';
    case AttendanceSheetNotificationEnum.FOLHA_ASSINADA:
      return 'Assinatura Pendente';
    case AttendanceSheetNotificationEnum.FOLHA_REJEITADA:
      return 'Folha para Corrigir';
    case AttendanceSheetNotificationEnum.FOLHA_CONCLUIDA:
      return 'Folha Concluída';
    default:
      return '-';
  }
};